import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  button: {
    width: "5%",
    border: "1px solid blue",
    margin: "1%",
    "&:hover": {
      backgroundColor: "blue",
      color: "white",
    },
  },
  input: {
    margin: "0 0 24px 0",
    flexBasis: { xs: "100%", sm: "75%", lg: "46%" },
  },
  label: {
    position: "relative",
  },
  selectWrapper: {
    minWidth: "50px",
    borderTopRightRadius: "0px",
  },
  autoComplete: {
    mt: "30px",
  },
  flexContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  renderButtonText: {
    display: "block",
    textAlign: "left",
    fontSize: "17px",
  },
  renderButtonText2: {
    display: "block",
    textAlign: "left",
    fontSize: "18px",
    fontWeight: "600",
    color: "#36B1A0",
    textDecoration: "none",
  },
  formWrapper: {
    margin: "20px 0",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#36B1A0",
    padding: "15px 20px",
    borderRadius: "15px",
    maxWidth: { xs: "100%", lg: "100%" },
    display: "flex",
    backgroundColor: "#EBFAF8",
  },
  documentGroup: {
    display: "flex",
    gap: "2%",
    margin: "10px 10px",
  },
  memberListHeading: {
    fontSize: "24px",
    fontWeight: "600",
    color: "primary.main",
  },

  cardWrapper: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "16px",
    maxWidth: "400px",
    minWidth: "300px",
    margin: "16px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f9f9f9",
  },
  heading: {
    fontSize: "18px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: "#36B1A0",
    marginBottom: "30px",
  },
  inputLabel: {
    fontSize: "14px",
    mt: "15px",
  },
  inputWrapper: {
    minWidth: "100px",
    borderTopRightRadius: "0px",
    borderColor: "unset",
  },
  inputBorder: {
    borderColor: "#36B1A0;",
    boxShadow: "unset",
  },
});

export default styles;
